import StudentExamList from '../../slices/student_exam/StudentExamList'
import StartStudentExam from '../../slices/student_exam/StartStudentExam'
import StudentExamAnswer from '../../slices/student_exam/StudentExamAnswer'
import StudentExamSubmit from '../../slices/student_exam/StudentExamSubmit'
import StudentExamDetails from '../../slices/student_exam/StudentExamDetails'
import UploadStudentExamRecording from '../../slices/student_exam/UploadStudentExamRecording'
import StudentExamRecording from '../../slices/student_exam/StudentExamRecording'
import StudentExamRecordingChunks from '../../slices/student_exam/StudentExamRecordingChunks'
import DownloadStudentExamRecording from '../../slices/student_exam/DownloadStudentExamRecording'

const studentExamReducer = {
    studentExamList: StudentExamList,
    startStudentExam: StartStudentExam,
    studentExamAnswer: StudentExamAnswer,
    studentExamSubmit: StudentExamSubmit,
    studentExamDetails: StudentExamDetails,
    uploadStudentExamRecording: UploadStudentExamRecording,
    studentExamRecording: StudentExamRecording,
    studentExamRecordingChunks: StudentExamRecordingChunks,
    downloadStudentExamRecording: DownloadStudentExamRecording,
};

export default studentExamReducer;
